// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__-niGk","customLoader":"Loader_customLoader__s7HFi","s3":"Loader_s3__JZUhe"};